const NoPage = () => {
  return (
    <>
      <style>{styles}</style>
      <div className="nopage-root">
        {/* Ambient orbs */}
        <div className="nopage-orb nopage-orb1" />
        <div className="nopage-orb nopage-orb2" />
        <div className="nopage-orb nopage-orb3" />

        {/* Dot grid */}
        <div className="nopage-grid" />

        {/* Glitch 404 */}
        <div className="nopage-center">
          <div className="nopage-404-wrap">
            <span className="nopage-404" data-text="404">404</span>
          </div>

          <div className="nopage-divider" />

          <p className="nopage-title">Page Not Found</p>
          <p className="nopage-sub">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <a className="nopage-btn" href="/">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M19 12H5M5 12l7-7M5 12l7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back to Home
          </a>
        </div>

        {/* Floating decorative rings */}
        <div className="nopage-ring nopage-ring1" />
        <div className="nopage-ring nopage-ring2" />
        <div className="nopage-ring nopage-ring3" />
      </div>
    </>
  );
};

export default NoPage;

const styles = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .nopage-root {
    position: fixed;
    inset: 0;
    background: linear-gradient(160deg, #0a0a0f 0%, #12121a 40%, #0d0d15 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  /* ── Dot grid ── */
  .nopage-grid {
    position: fixed;
    inset: 0;
    background-image: radial-gradient(rgba(232,27,35,0.1) 1px, transparent 1px);
    background-size: 36px 36px;
    pointer-events: none;
    z-index: 0;
    mask-image: radial-gradient(ellipse 70% 70% at 50% 50%, black 20%, transparent 100%);
    -webkit-mask-image: radial-gradient(ellipse 70% 70% at 50% 50%, black 20%, transparent 100%);
  }

  /* ── Orbs ── */
  .nopage-orb {
    position: fixed;
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
  }
  .nopage-orb1 {
    top: -15%; left: -10%;
    width: 600px; height: 600px;
    background: radial-gradient(circle, rgba(232,27,35,0.2) 0%, rgba(232,27,35,0.04) 50%, transparent 70%);
    filter: blur(8px);
    animation: orbFloat1 12s ease-in-out infinite;
  }
  .nopage-orb2 {
    bottom: -20%; right: -10%;
    width: 700px; height: 700px;
    background: radial-gradient(circle, rgba(180,10,18,0.16) 0%, rgba(120,0,10,0.05) 50%, transparent 70%);
    filter: blur(12px);
    animation: orbFloat2 16s ease-in-out infinite;
  }
  .nopage-orb3 {
    top: 40%; left: 30%;
    width: 400px; height: 400px;
    background: radial-gradient(circle, rgba(255,80,80,0.07) 0%, transparent 70%);
    filter: blur(20px);
    animation: orbFloat3 20s ease-in-out infinite;
  }

  /* ── Ripple rings ── */
  .nopage-ring {
    position: fixed;
    border-radius: 50%;
    border: 1px solid rgba(232,27,35,0.15);
    pointer-events: none;
    z-index: 0;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
  }
  .nopage-ring1 { width: 500px; height: 500px; animation: ringPulse 4s ease-out infinite; }
  .nopage-ring2 { width: 700px; height: 700px; animation: ringPulse 4s ease-out infinite 1.3s; }
  .nopage-ring3 { width: 900px; height: 900px; animation: ringPulse 4s ease-out infinite 2.6s; }

  /* ── Center content ── */
  .nopage-center {
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    animation: reveal 0.8s cubic-bezier(0.22, 1, 0.36, 1);
  }

  /* ── Glitch 404 ── */
  .nopage-404-wrap {
    position: relative;
    line-height: 1;
    margin-bottom: 4px;
  }
  .nopage-404 {
    position: relative;
    display: block;
    font-size: clamp(120px, 22vw, 220px);
    font-weight: 900;
    letter-spacing: -0.04em;
    color: transparent;
    -webkit-text-stroke: 2px rgba(232,27,35,0.6);
    text-shadow:
      0 0 40px rgba(232,27,35,0.35),
      0 0 80px rgba(232,27,35,0.15);
    animation: glitchText 6s infinite;
    user-select: none;
  }

  /* Glitch pseudo layers */
  .nopage-404::before,
  .nopage-404::after {
    content: attr(data-text);
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    font-size: inherit;
    font-weight: inherit;
    letter-spacing: inherit;
    color: transparent;
  }
  .nopage-404::before {
    -webkit-text-stroke: 2px rgba(232,27,35,0.4);
    animation: glitchBefore 6s infinite;
    clip-path: polygon(0 30%, 100% 30%, 100% 55%, 0 55%);
  }
  .nopage-404::after {
    -webkit-text-stroke: 2px rgba(100,200,255,0.25);
    animation: glitchAfter 6s infinite;
    clip-path: polygon(0 60%, 100% 60%, 100% 80%, 0 80%);
  }

  /* ── Divider ── */
  .nopage-divider {
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, transparent, #e81b23, transparent);
    border-radius: 3px;
    box-shadow: 0 0 12px rgba(232,27,35,0.6);
    margin: 16px 0 24px;
    animation: dividerGlow 2.5s ease-in-out infinite;
  }

  .nopage-title {
    color: #f0f0f5;
    font-size: clamp(1.2rem, 3vw, 1.8rem);
    font-weight: 700;
    letter-spacing: 0.04em;
    text-align: center;
    margin-bottom: 10px;
  }
  .nopage-sub {
    color: rgba(180,180,200,0.45);
    font-size: 0.9rem;
    letter-spacing: 0.04em;
    text-align: center;
    max-width: 340px;
    line-height: 1.6;
    margin-bottom: 36px;
  }

  /* ── Button ── */
  .nopage-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 13px 28px;
    background: #e81b23;
    border-radius: 12px;
    color: #fff;
    font-size: 0.92rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-decoration: none;
    box-shadow: 0 4px 20px rgba(232,27,35,0.4);
    transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
    position: relative;
    overflow: hidden;
  }
  .nopage-btn::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.18), transparent);
    background-size: 200% 100%;
    background-position: -200% center;
    transition: background-position 0.45s ease;
  }
  .nopage-btn:hover {
    background: #c8121a;
    transform: translateY(-3px) scale(1.03);
    box-shadow: 0 10px 32px rgba(232,27,35,0.55);
  }
  .nopage-btn:hover::after { background-position: 200% center; }
  .nopage-btn:active { transform: translateY(0) scale(1); }

  /* ── Keyframes ── */
  @keyframes orbFloat1 {
    0%,100% { transform: translate(0,0) scale(1); }
    33% { transform: translate(60px,-80px) scale(1.15); }
    66% { transform: translate(-40px,40px) scale(0.9); }
  }
  @keyframes orbFloat2 {
    0%,100% { transform: translate(0,0) scale(1); }
    33% { transform: translate(-70px,50px) scale(1.1); }
    66% { transform: translate(50px,-60px) scale(0.95); }
  }
  @keyframes orbFloat3 {
    0%,100% { transform: translate(0,0) scale(1); }
    50% { transform: translate(40px,60px) scale(1.2); }
  }
  @keyframes ringPulse {
    0%   { opacity: 0.5; transform: translate(-50%,-50%) scale(0.85); }
    100% { opacity: 0;   transform: translate(-50%,-50%) scale(1.15); }
  }
  @keyframes reveal {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes dividerGlow {
    0%,100% { opacity: 0.5; transform: scaleX(0.7); }
    50%      { opacity: 1;   transform: scaleX(1); }
  }
  @keyframes glitchText {
    0%,90%,100% { transform: translate(0); }
    92% { transform: translate(-3px, 1px); }
    94% { transform: translate(3px, -1px); }
    96% { transform: translate(-2px, 2px); }
    98% { transform: translate(2px, -2px); }
  }
  @keyframes glitchBefore {
    0%,90%,100% { transform: translate(0); opacity: 0; }
    92% { transform: translate(4px, 0); opacity: 1; }
    96% { transform: translate(-4px, 0); opacity: 1; }
    98% { transform: translate(0); opacity: 0; }
  }
  @keyframes glitchAfter {
    0%,90%,100% { transform: translate(0); opacity: 0; }
    93% { transform: translate(-4px, 0); opacity: 1; }
    97% { transform: translate(4px, 0); opacity: 1; }
    99% { transform: translate(0); opacity: 0; }
  }

  @media (max-width: 480px) {
    .nopage-ring1 { width: 300px; height: 300px; }
    .nopage-ring2 { width: 450px; height: 450px; }
    .nopage-ring3 { width: 600px; height: 600px; }
  }
`;